//解析HTML语句，用于试题内容之类需要处理HTML元素事件处。
import { lwHtml } from "./lwHtml";
import { lwWatchMouse } from "./watchMouse";
import {preventDbClick} from "./preventDbClick";
import {scaleWidth } from './scaleWidth.directive'
/**
 * 指令总入口
 * @param {*} Vue 实例
 */
export const DirectiveInit = (Vue) => {
  lwHtml(Vue)
  lwWatchMouse(Vue)
  preventDbClick(Vue)
  scaleWidth(Vue)
};
